// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoCard_wrapper__SZrq6","image":"InfoCard_image__X9NN8","image--dark":"InfoCard_image--dark__n5Zie","image--light":"InfoCard_image--light__KH0_r"};